<ng-container *ngIf="!comment">
    <div class="new-comment-wrapper" *ngIf="user || commentInputBoxEnabled">
        <div *ngIf="user && !user.exists" class="body-1">
            {{ user.display_name | b64 }}
        </div>
        <app-comment-input
            label="Your comment"
            placeholder="Your comment"
            [(value)]="newComment"
            [contentLength]="contentLength"
            actionButtonLabel="Post comment"
            (action)="createComment()"
            [disabledAction]="!newComment.trim() && !isCreatingNewComment"
            [showActionLoading]="isCreatingNewComment"
        ></app-comment-input>
        <!-- / INPUT BOX BUTTONS -->
    </div>

    <!-- ANONYMOUS USER PROMPT -->
    <div class="signed-out-wrapper" *ngIf="!user && anonymousPromptEnabled">
        <div class="subtitle-1">You are not signed in.</div>
        <a [href]="loginUrl + '?return_to_link=' + currentPath">
            <sync-button
                type="filled"
                label="Sign in to comment">
            </sync-button>
        </a>
        <sync-button
            *ngIf="link.allow_comment === 2"
            type="outlined"
            label="Post anonymously"
            [onClick]="postAnonymouslyClick">
        </sync-button>
    </div>
    <!-- / ANONYMOUS USER PROMPT -->

    <!-- ANONYMOUS FORM -->
    <div class="signed-out-new-comment-wrapper" *ngIf="anonymousFormEnabled">
        <app-comment-input
            *ngIf="anonymousFormEnabled"
            label="Your comment"
            placeholder="Your comment"
            [(value)]="anonymousComment"
            [contentLength]="contentLength"
            actionButtonLabel="Post comment"
            (action)="submitAnonymousForm()"
            [disabledAction]="!anonymousComment.trim() || !anonymousName.trim()"
            [showActionLoading]="isCreatingNewComment"
            [(anonymousName)]="anonymousName"
        ></app-comment-input>
    </div>
    <!-- / ANONYMOUS FORM -->
</ng-container>

<!-- / COMMENT INPUT BOX -->
<app-error [errcode]="errCode"></app-error>
<!-- COMMENT OUTER BOX -->
<ng-container *ngIf="comment">

    <div class="comment-container">
        <ng-container *ngIf="!editMode && !confirmedDelete">
            <div class="comment-user-heading">
                <sync-list [isSelectable]="false" [ListItems]="[{
                    isInteractive: false,
                    primaryText: comment.author_name | b64,
                    secondaryText: comment.updated_at | relativeTime,
                    leadAdornmentConfig: {
                        enabled: true,
                        type: 'avatar',
                        size: 'large',
                        avatarConfig: {
                            type: 'avatar',
                            url: authorAvatar,
                            initials: comment.author_name | b64,
                            size: 40,
                            randomColor: true
                        }
                    },
                    trail1AdornmentConfig: {
                        enabled: user?.id === comment.author_id && tempSession === comment.temp_session,
                        type: 'iconButton',
                        size: 'large',
                        onClick: editComment,
                        iconButtonConfig : {
                            iconName: 'edit',
                            size: 'large',
                            tooltipText: 'Edit'
                        }
                    },
                    trail2AdornmentConfig: {
                        enabled: (user?.id === ownerId || (user && user.exists && user?.id === comment.author_id)),
                        type: 'iconButton',
                        size: 'large',
                        onClick: toggleConfirm,
                        iconButtonConfig : {
                            iconName: 'delete',
                            size: 'large',
                            tooltipText: 'Delete'
                        }
                    }
                }]"></sync-list>
            </div>
            <div class="comment-text body-2">
                {{comment.content}}
            </div>
        </ng-container>
        <app-comment-input
            *ngIf="editMode"
            label="Your comment"
            placeholder="Your comment"
            [(value)]="commentEdition"
            [contentLength]="contentLength"
            actionButtonLabel="Save changes"
            (action)="updateComment()"
            (cancel)="cancelEditMode()"
            [disabledAction]="!commentEdition.trim() && !isCreatingNewComment"
            [showActionLoading]="isCreatingNewComment"
        ></app-comment-input>
        <div class="confirm-delete" *ngIf="confirmedDelete">
            <div class="subtitle-2">Are you sure you want to delete this comment?</div>
            <div class="body-2">{{comment.content}}</div>
            <div class="comment-form-buttons">
                <sync-button class="cancel-comment-button"
                    type="flat"
                    label="Cancel"
                    [onClick]="cancelConfirm">
                </sync-button>
                <sync-button class="post-comment-button"
                    color="critical"
                    type="filled"
                    [onClick]="deleteComment"
                    label="Delete comment">
                </sync-button>
            </div>
        </div>
    </div>

    <!-- REPLY TREE -->
    <ng-container *ngFor="let reply of comment.replies">
        <sync-divider></sync-divider>
        <app-reply [reply]="reply" [ownerId]="ownerId" [user]="user" [link]="link"
            [tempSession]="tempSession" (replyEditionEvent)="updateReply($event)"
            (replyDeletionEvent)="deleteReply($event)"></app-reply>
    </ng-container>
    <!-- / REPLY TREE -->

    <sync-divider></sync-divider>
    <!-- REPLY DETAIL TOGGLE BUTTONS -->
    <div class="comment-reply-input-wrapper">
        <div class="reply-button-container" *ngIf="!replyInputBoxEnabled && !replyAnonymousPromptEnabled  && !anonymousFormEnabled">
            <sync-button class="reply-comment-button"
                type="flat"
                label="Reply"
                [onClick]="toggleReplyInputBox">
            </sync-button>
        </div>
        <!-- REPLY INPUT BOX -->
        <ng-container *ngIf="
                replyInputBoxEnabled &&
                !replyAnonymousPromptEnabled &&
                !replyAnonymousFormEnabled
            ">
            <app-reply [isInputBox]="true" [user]="user" [tempSession]="tempSession" [commentID]="comment._id"
                [link]="link" (replyCreationEvent)="createReply($event)"
                (toggleReplyInputBoxEvent)="toggleReplyInputBox()"></app-reply>
        </ng-container>
        <!-- /REPLY INPUT BOX -->

        <!-- ANONYMOUS USER PROMPT -->
        <div class="signed-out-wrapper" *ngIf="replyAnonymousPromptEnabled && !replyInputBoxEnabled && !replyAnonymousFormEnabled">
            <div class="subtitle-1">You are not signed in.</div>
            <a [href]="loginUrl + '?return_to_link=' + currentPath">
                <sync-button
                    type="filled"
                    label="Sign in to comment">
                </sync-button>
            </a>
            <sync-button
                *ngIf="link.allow_comment === 2"
                type="outlined"
                label="Post anonymously"
                [onClick]="postAnonymouslyClick">
            </sync-button>
        </div>
        <!-- / ANONYMOUS USER PROMPT -->

        <div class="signed-out-new-comment-wrapper" *ngIf="anonymousFormEnabled">
            <app-comment-input
                *ngIf="anonymousFormEnabled"
                label="Your comment"
                placeholder="Your comment"
                [(value)]="anonymousReply"
                [contentLength]="contentLength"
                actionButtonLabel="Post comment"
                (action)="submitReplyAnonymousForm()"
                [disabledAction]="!anonymousReply.trim() || !anonymousName.trim()"
                [showActionLoading]="isCreatingNewComment"
                [(anonymousName)]="anonymousName"
            ></app-comment-input>
        </div>
    </div>
</ng-container>